import axios from 'axios';
import authHeader from "@/service/auth-header";

class SprintService {

    async getCompanySprints(companyId, params, search, status, start, end) {
        try {
            const newParams = {};

            if (params.sortField) {
                newParams.sortField = params.sortField;
            } else {
                newParams.sortField = "name";
            }

            if (params.sortOrder) {
                newParams.sortOrder = params.sortOrder;
            } else {
                newParams.sortOrder = "asc";
            }

            if (search) {
                newParams.search = search;
            }

            if (status) {
                newParams.status = status;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            const response = await axios.get(`/api/sprint/${companyId}`, {
                headers: authHeader(),
                params: {
                    page: params.first / params.rows + 1,
                    size: params.rows,
                    sort: newParams.sortField,
                    order: newParams.sortOrder,
                    search: newParams.search,
                    status: newParams.status,
                    start: newParams.start,
                    end: newParams.end
                }
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[SprintService][getCompanySprints] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }

    searchCompanySprints(companyId, sprintName) {
        return axios.get(`/api/sprint/${companyId}/${sprintName}`, {headers: authHeader()})
    }

    getSprint(sprintId) {
        return axios.get(`/api/sprint/specific/${sprintId}`, {headers: authHeader()})
    }

    createSprint(data) {
        return axios.post(`/api/sprint`, data, {headers: authHeader()});
    }

    updateSprint(data) {
        return axios.put(`/api/sprint`, data, {headers: authHeader()});
    }

    deleteSprint(sprintId) {
        return axios.delete(`/api/sprint/${sprintId}`,{ headers: authHeader() })
    }

}

export default new SprintService();
